import { db } from './index'
import { hostings, type NewHosting, type Hosting } from './schema'
import { eq } from 'drizzle-orm'

export async function createHosting(data: NewHosting) {
  const [row] = await db.insert(hostings).values(data).returning()
  return { success: true, data: row }
}

export async function listHostings() {
  const rows = await db.select().from(hostings)
  return { success: true, data: rows }
}

export async function getHosting(id: string) {
  const [row] = await db.select().from(hostings).where(eq(hostings.id, id))
  return { success: true, data: row || null }
}

export async function updateHosting(id: string, data: Partial<Hosting>) {
  const [row] = await db.update(hostings).set({ ...data, updatedAt: new Date() }).where(eq(hostings.id, id)).returning()
  return { success: true, data: row }
}

export async function deleteHosting(id: string) {
  const [row] = await db.delete(hostings).where(eq(hostings.id, id)).returning()
  return { success: true, data: row }
}